<script lang="ts">
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import QualityDocumentManager from "../../QualityDocument/QualityDocumentManager.svelte";
</script>

<QualityLayout>
  <QualityDocumentManager entityName="scadenziario analisi" clfDocTypeCode="SCDZANALIS" withVersion={false} />
</QualityLayout>
